import { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { baseApiURL } from "../../../baseUrl";
import { FiUpload, FiUser, FiMail, FiShield } from "react-icons/fi";

const AddAdmin = () => {
  const [file, setFile] = useState();
  const [data, setData] = useState({
    employeeId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    gender: "",
  });
  const [previewImage, setPreviewImage] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    const imageUrl = URL.createObjectURL(selectedFile);
    setPreviewImage(imageUrl);
  };

  const addAdminProfile = (e) => {
    e.preventDefault();
    toast.loading("Adding Admin");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const formData = new FormData();
    Object.keys(data).forEach((key) => formData.append(key, data[key]));
    formData.append("type", "profile");
    formData.append("profile", file);

    axios
      .post(`${baseApiURL()}/admin/details/addDetails`, formData, {
        headers: headers,
      })
      .then((response) => {
        toast.dismiss();
        if (response.data.success) {
          toast.success(response.data.message);
          axios
            .post(`${baseApiURL()}/Admin/auth/register`, {
              loginid: data.employeeId,
              password: data.employeeId,
            })
            .then((response) => {
              toast.dismiss();
              if (response.data.success) {
                toast.success(response.data.message);
                resetForm();
              } else {
                toast.error(response.data.message);
              }
            })
            .catch((error) => {
              toast.dismiss();
              toast.error(error.response.data.message);
            });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error(error.response.data.message);
      });
  };

  const resetForm = () => {
    setFile(null);
    setData({
      employeeId: "",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      gender: "",
    });
    setPreviewImage("");
  };

  return (
    <div className="space-y-6">
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white flex items-center gap-2">
            <FiShield className="text-indigo-600 dark:text-indigo-400" /> Add New Admin
          </h1>
          <p className="text-slate-500 dark:text-slate-400 font-medium text-xs mt-0.5">Register a new administrator profile</p>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xs border border-slate-200 dark:border-slate-800 p-6">
        {/* Form */}
        <form onSubmit={addAdminProfile} className="space-y-6">
          {/* Personal Information Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <FiUser className="text-indigo-600 dark:text-indigo-400 text-base" />
              <h2 className="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">Personal Information</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstname" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  First Name *
                </label>
                <input
                  type="text"
                  id="firstname"
                  required
                  value={data.firstName}
                  onChange={(e) => setData({ ...data, firstName: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter first name"
                />
              </div>
              <div>
                <label htmlFor="middlename" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Middle Name
                </label>
                <input
                  type="text"
                  id="middlename"
                  value={data.middleName}
                  onChange={(e) => setData({ ...data, middleName: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter middle name"
                />
              </div>
              <div>
                <label htmlFor="lastname" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Last Name *
                </label>
                <input
                  type="text"
                  id="lastname"
                  required
                  value={data.lastName}
                  onChange={(e) => setData({ ...data, lastName: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter last name"
                />
              </div>
              <div>
                <label htmlFor="employeeId" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Employee ID *
                </label>
                <input
                  type="text"
                  id="employeeId"
                  required
                  value={data.employeeId}
                  onChange={(e) => setData({ ...data, employeeId: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none font-mono"
                  placeholder="Enter employee ID"
                />
              </div>
              <div>
                <label htmlFor="gender" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Gender *
                </label>
                <select
                  id="gender"
                  required
                  value={data.gender}
                  onChange={(e) => setData({ ...data, gender: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                >
                  <option value="">Select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
          </div>

          {/* Contact Information Section */}
          <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
            <div className="flex items-center space-x-2 mb-4">
              <FiMail className="text-indigo-600 dark:text-indigo-400 text-base" />
              <h2 className="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">Contact Information</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="email" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  value={data.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter email address"
                />
              </div>
              <div>
                <label htmlFor="phoneNumber" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phoneNumber"
                  required
                  value={data.phoneNumber}
                  onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
          </div>

          {/* Profile Picture Section */}
          <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
            <div className="flex items-center space-x-2 mb-4">
              <FiUpload className="text-indigo-600 dark:text-indigo-400 text-base" />
              <h2 className="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">Profile Picture</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
              <div>
                <label htmlFor="file" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Upload Photo
                </label>
                <div className="relative">
                  <input
                    type="file"
                    id="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <div className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border-2 border-dashed border-slate-200 dark:border-slate-800 rounded-xl hover:border-indigo-500 transition cursor-pointer">
                    <div className="flex items-center justify-center space-x-2">
                      <FiUpload className="text-slate-400 text-base" />
                      <span className="text-xs font-medium text-slate-600 dark:text-slate-400">
                        {previewImage ? "Change photo" : "Click to upload photo"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {previewImage && (
                <div className="flex items-center justify-center">
                  <div className="relative">
                    <img
                      src={previewImage}
                      alt="Profile Preview"
                      className="w-20 h-20 object-cover rounded-xl border border-slate-200 dark:border-slate-700 shadow-xs"
                    />
                    <div className="absolute -top-2 -right-2 bg-emerald-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-[10px] font-bold">
                      ✓
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-end space-x-3 pt-6 border-t border-slate-100 dark:border-slate-800">
            <button
              type="button"
              onClick={resetForm}
              className="px-4 py-2.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-bold transition cursor-pointer"
            >
              Reset Form
            </button>
            <button
              type="submit"
              className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-bold shadow-xs transition cursor-pointer"
            >
              Add Admin
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdmin;
